<template>
  <div class="social-links">
    <a
      href="https://www.facebook.com/MiniaturWunderlandHamburg"
      target="_blank"
      class="social-links__link"
    >
      <span class="sr-only">Facebook</span>
      <icon
        class="social-links__icon"
        type="facebook"
        :size="1.5"
      />
    </a>
    <a
      href="https://twitter.com/miwula"
      target="_blank"
      class="social-links__link"
    >
      <span class="sr-only">Twitter</span>
      <icon
        class="social-links__icon"
        type="twitter"
        :size="1.5"
      />
    </a>
    <a
      href="https://instagram.com/miniaturwunderland/"
      target="_blank"
      class="social-links__link"
    >
      <span class="sr-only">Instagram</span>
      <icon
        class="social-links__icon"
        type="instagram"
        :size="1.5"
      />
    </a>
    <a
      href="https://www.youtube.com/user/MiWuLaTV"
      target="_blank"
      class="social-links__link"
    >
      <span class="sr-only">YouTube</span>
      <icon
        class="social-links__icon"
        type="youtube"
        :size="1.75"
      />
    </a>
  </div>
</template>

<script>
import icon from './icon.vue'

export default {
  name: 'CSocalLinks',

  components: {
    icon
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.social-links {
  display: flex;
  align-items: center;
}

.social-links__link {
  display: block;
  padding: 0.25em;
  color: $color-strong;

  &:hover,
  &:focus {
    color: $color-primary-dark;
  }

  @media (min-width: $breakpoint-lg) {
    padding: 0.125em;
  }
}

.social-links__icon {
  display: block;
  font-size: 1.25em;

  @media (min-width: $breakpoint-lg) {
    font-size: 1em;
  }
}
</style>
